import React from 'react';
import { Link } from 'react-router-dom';


function Admin(props) {
    return (
        <div>
             <h1>Welcome</h1>
        </div>
    );
}

export default Admin;





































